/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'util/PropTypes';

import {  Label, TruncatedText } from '@ba/ba-ui-carbon-toolkit';

import './CompareChartHeader.scss';

import StringResources from 'nls/StringResources';

const truncatedTextStyle =  { maxWidth: '80%' };

/**
* Simple control to show label of the chart (appears on top of the visualization in compare card)
*/
@observer
export default class CompareChartHeader extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const id = `chartHeader_${this.props.label}`;
		const idSub = `subLabel_${this.props.label}`;
		const label = StringResources.get('compareChartHeader', { name:this.props.label } );
		const subLabel = this.props.subLabel;
		let subLabelMarkup = null;
		if(subLabel) {
			subLabelMarkup = <TruncatedText style={truncatedTextStyle} className="CompareChartHeader__subLabel" id={idSub} location="end" value={subLabel}/>;
		}
		return (
			<div role="heading" aria-labelledby={id} className="CompareChartHeader">
				<Label className="CompareChartHeader__label" id={id} label={label}/>
				{subLabelMarkup}
			</div>
		);

	}


}

CompareChartHeader.propTypes = {
	label: PropTypes.string,
	subLabel: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/js/components/lwstats/CompareChartHeader.js